// extracted by mini-css-extract-plugin
export default {"switch-container":"Switch_switch-container__ITskl","checkbox":"Switch_checkbox__ka6NS","switch":"Switch_switch__fOfrM","slider":"Switch_slider__F+dLY"};